var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment } from "react";
import styled from "styled-components";
import { getColor } from "../../theme";
import { Text, H5 } from "../../components/typography";
import { Icon } from "../../components/icon";
import { Button } from "../../components/button";
import Flex from "../../components/templates/flex";
var Anchor = styled(Text).attrs({ as: "a", target: "_blank" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    text-decoration: none;\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n      text-decoration: none;\n    }\n  }\n"], ["\n  &&& {\n    text-decoration: none;\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n      text-decoration: none;\n    }\n  }\n"])), getColor("primary"), getColor("accent"));
var Section = function (_a) {
    var icon = _a.icon, title = _a.title, content = _a.content, url = _a.url, children = _a.children, testid = _a.testid, label = _a.label, onClick = _a.onClick;
    return (React.createElement(Flex, { width: "100%", column: true, gap: 2 },
        React.createElement(Flex, { gap: 2, alignItems: "center" },
            React.createElement(Icon, { color: "text", name: icon, width: "18px", height: "18px" }),
            React.createElement(H5, { margin: [0] }, title)),
        React.createElement(Flex, { column: true, gap: 4, padding: [0, 2] },
            React.createElement(Text, null, content),
            React.createElement(Button, __assign({ width: "100%", onClick: onClick, label: label, "data-testid": testid }, (url && { as: "a", target: "_blank", href: url }))),
            children)));
};
var propsByApp = {
    cloud: {
        documentationUrl: "https://learn.netdata.cloud/",
        issuesUrl: "https://github.com/netdata/netdata-cloud/issues/new?assignees=manos-saratsis&labels=bug&template=submig-a-bug-for-netdata-cloud.md&title=%5BBUG%5D",
        issuesLabel: "Let us know about any bugs you’ve encountered in Netdata Cloud.",
        otherIssuesUrl: "https://github.com/netdata/netdata/issues/new?assignees=&labels=bug%2C+needs+triage&template=bug_report.md",
        otherIssuesLabel: "Agent",
        communityUrl: "https://community.netdata.cloud/c/support/cloud-support/15",
        communitySupportUrl: "https://www.netdata.cloud/community/",
    },
    agent: {
        documentationUrl: "https://learn.netdata.cloud/",
        issuesUrl: "https://github.com/netdata/netdata/issues/new?assignees=&labels=bug%2C+needs+triage&template=bug_report.md",
        issuesLabel: "Let us know about any bugs you’ve encountered in Netdata Agent.",
        otherIssuesUrl: "https://github.com/netdata/netdata-cloud/issues/new?assignees=manos-saratsis&labels=bug&template=submig-a-bug-for-netdata-cloud.md&title=%5BBUG%5D",
        otherIssuesLabel: "Cloud",
        communityUrl: "https://community.netdata.cloud/c/support/agent-support/14",
        communitySupportUrl: "https://www.netdata.cloud/community/",
    },
};
var General = function (_a) {
    var app = _a.app, onDashboardClick = _a.onDashboardClick, onVisitDocumentClick = _a.onVisitDocumentClick, onOpenIssueClick = _a.onOpenIssueClick, onOpenBugClick = _a.onOpenBugClick, onContributeClick = _a.onContributeClick, onSupportClick = _a.onSupportClick;
    var _b = propsByApp[app] || propsByApp.cloud, documentationUrl = _b.documentationUrl, issuesUrl = _b.issuesUrl, issuesLabel = _b.issuesLabel, communityUrl = _b.communityUrl, communitySupportUrl = _b.communitySupportUrl, otherIssuesUrl = _b.otherIssuesUrl, otherIssuesLabel = _b.otherIssuesLabel;
    return (React.createElement(Fragment, null,
        app === "agent" && (React.createElement(Fragment, null,
            React.createElement(Section, { icon: "dashboard", title: "Dashboard", content: "Learn how to interact with graphs using your mouse or touch interface.", testid: "dashboard-info", label: "Learn to use the Dashboard", onClick: onDashboardClick }),
            React.createElement(Flex, { width: "100%", height: { min: "1px" }, background: "disabled" }))),
        React.createElement(Section, { icon: "documentation", title: "Documentation", content: "View how-tos, reference docs, and tutorials to help you get the most out of Netdata Cloud.\n        ", url: documentationUrl, testid: "documentation-link", label: "Visit the docs", onClick: onVisitDocumentClick }),
        React.createElement(Section, { icon: "unknownError", title: "Report a Bug", content: issuesLabel, url: issuesUrl, testid: "documentation-report-bug-link", label: "Open a new Issue in Github", onClick: onOpenIssueClick },
            React.createElement(Text, null,
                "Found a bug with the Netdata ",
                otherIssuesLabel,
                "?",
                React.createElement(Anchor, { href: otherIssuesUrl, onClick: onOpenBugClick }, "Open an issue"),
                " ",
                "on Github")),
        React.createElement(Section, { icon: "community", title: "Community", content: "If you still need help, join Netdata\u2019s community forums to ask questions, discuss features, or make feature requests.", url: communityUrl, testid: "documentation-community-link", label: "Ask the community", onClick: onContributeClick },
            React.createElement(Button, { width: "100%", label: "Read more about Netdata\u2019s community", flavour: "hollow", as: "a", target: "_blank", href: communitySupportUrl, "data-testid": "documentation-community-support-link", onClick: onSupportClick }))));
};
export default General;
var templateObject_1;
